<template>
  <div>
    <el-upload v-if="isDuotu == false" class="avatar-uploader"
               :action="uploadUrl" name="file" :headers="headers"
               :show-file-list="false" v-loading="loading" :style="{width,height}" :on-success="handleAvatarSuccess"
               :class="{round:round}" :id="idkey" :before-upload="beforeUpload" multiple :on-error="err"
               accept="image/*"
               :key="idkey">
      <div class="el-upload-list--picture-card" v-if="imgUrl">
        <img :src="imgUrl" class="avatar el-upload-list__item-thumbnail" :style="{width,height}"/>
        <span class="el-upload-list__item-actions" :style="{width,height}" @click.stop>
					<span class="el-upload-list__item-preview" @click.stop="handlePictureCardPreview(imgUrl)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span class="el-upload-list__item-preview" v-if="!dis">

						<i class="el-icon-upload2" @click.stop="upload"></i>
					</span>
          <!--					<span v-if="!dis"-->
          <!--                class="el-upload-list__item-delete"-->
          <!--                @click.stop="delimg()"-->
          <!--          >-->
          <!--					          <i class="el-icon-delete"></i>-->
          <!--					        </span>-->
				</span>
      </div>
      <span v-if="!imgUrl" style="font-size: 14px;color: #666;">点击上传</span>

    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import {baseUrl} from "@/utils/config";
import {getToken} from "@/utils/cache";

export default {
  name: "upload",
  props: {
    imgUrl: {
      type: [Array, String],
      default: () => ''
    },
    width: {
      type: String,
      default: () => '300px'
    },
    height: {
      type: String,
      default: () => '200px'
    },
    round: {
      type: Boolean,
      default: () => false
    },
    dis: {
      type: Boolean,
      default: () => false
    },
    idkey: {
      type: String,
      default: () => 'avatar-uploader'
    },
    isDuotu: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {},
  data() {
    return {
      uploadUrl: baseUrl + '/api/common/upload',
      dialogImageUrl: '',
      dialogVisible: false,
      loading: false,
      headers: {
        token: ''
      },
      disabled: false,
      pictureLists: []
    };
  },
  created() {
    this.headers.token = getToken()
  },
  methods: {
    delimg() {
      this.$emit("removeimg");
    },
    //删除
    handleRemove(file) {
      const url = file.response.data.url
      const arr = []
      this.pictureLists.forEach((element) => {
        if (element !== url) {
          arr.push(element)
        }
      })
      this.pictureLists = arr
      this.$emit("getImg", this.pictureLists);
    },
    // 上传多图上传成功
    handlePic(res, file) {
      const that = this
      this.loading = false
      if (!res) {
        return
      }
      if (res.status == 1) {
        this.$message.success('上传图片成功');
        that.pictureLists.push(res.data.path)
        this.$emit("getImg", this.pictureLists);
      } else {
        this.$message.error(res.info);
      }
    },
    //单图上传成功
    handleAvatarSuccess(res, file) {
      this.loading = false
      if (!res) {
        return
      }
      if (res.code == 1) {
        this.$emit("getImg", res.data);
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeUpload(file) {
      this.loading = true

    },
    handlePictureCardPreview(imgUrl) {
      this.dialogImageUrl = imgUrl;
      this.dialogVisible = true;
    },
    upload() {
      document.querySelector('#' + this.idkey + ' input').click()
    },
    err(e) {
      this.loading = false
      console.log(e)
    },

  },
};
</script>
<style>
.avatar-uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F2F3F5;
  border-radius: 5px;
}
</style>
<style scoped>

.avatar-uploader .el-upload {


  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

}

.round {
  /* border-radius: 50%; */
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;

  /* border: 1px dashed #d9d9d9; */
}

.avatar {
  width: 180px;
  height: 180px;
  display: block;
  object-fit: cover;
}
</style>
